import {
  REQUEST_PENDING_TREATEMENT_CLAIMS,
  SET_PENDING_TREATEMENT_CLAIMS,
  REQUEST_SEARCH_PENDING_TREATEMENT_CLAIMS,
} from 'containers/ManagerPendingTreatementClaims/constants';

export const requestPendingTreatementClaims = (payload: any) => {
  return {
    type: REQUEST_PENDING_TREATEMENT_CLAIMS,
    payload,
  };
};

export const setPendingTreatementClaims = (payload: any) => {
  return {
    type: SET_PENDING_TREATEMENT_CLAIMS,
    payload,
  };
};
export const requestSearchPendingTreatementClaims = (payload: any) => {
  return {
    type: REQUEST_SEARCH_PENDING_TREATEMENT_CLAIMS,
    payload,
  };
};
